import { FormData } from "./types";

export const DEFAULT_VALUES: FormData = {
  name: "",
  storageUri: "",
};
